import Vue from 'vue';

/* This component is deprecated. Use ed-input-field instead */
export default Vue.component('ed-input-form', {
  name: 'ed-input-form',
  props: [
    'label', 
    'type',
    'disclamer',
    'placeholder',
    'readonly',
    'passwordIcon',
    'maxlength',
    'suffix',
    'isFit'
  ],
  inheritAttrs: false,
  data: () => {
    return {
      item: {},
      required: false
    }
  },
  computed: {
    inputClass() {
      return {
        disabled: this.readonly
      }
    }
  },
  validations() {
    return {
      value: this.$attrs.value ? this.$attrs.value.validators : {}
    };
  },
  methods: {
    onKeyUp(event) {
      this.$emit('keyup', event);
    },
    onBlur() {
      this.$emit('blur');
    },
    onInput() {
      this.$emit('input', this.item);
    }
  },
  created() {
    this.$attrs.value.validators = this.$attrs.value.validators ? this.$attrs.value.validators : {};
    this.required = !!this.$attrs.value.validators.required;
    this.item = this.$attrs.value;
  },
  watch: {
    $attrs() {
      if(this.$attrs.value) {
        Vue.set(this, 'item', {
          valid: this.$attrs.value.valid,
          validators: this.$attrs.value.validators,
          value: this.$attrs.value.value,
        });
      }
    }
  }
});
